import WorkOrderEdit from './edit.vue'
import WorkOrderList from './list.vue'
import WorkOrderInfo from './info.vue'
import deviceWorkOrderList from './devicelist.vue'


import * as OrderCompleted from './completed'
import * as OrderProcessing from './processing'
import * as WorkOrderRepair from './repair.vue'
import * as WorkOrderTrack from './track.vue'
import * as WorkOrderEvaluate from './evaluate.vue'
import * as WorkOrderChange from './change.vue'
import * as WorkOrderChanges from './question.vue'
import * as WorkOrderEditPro from './editProcessing.vue'
import * as WorkOrderexpenseAccount from './expenseAccount.vue'
import  deviceInfoTime from './infotime.vue'





let a = Object.assign({ WorkOrderEdit, WorkOrderList,deviceWorkOrderList,deviceInfoTime, WorkOrderInfo, WorkOrderRepair, WorkOrderTrack,WorkOrderEvaluate,WorkOrderChange,WorkOrderChanges,WorkOrderEditPro,WorkOrderexpenseAccount }, OrderCompleted, OrderProcessing)
export default a
